import React, { memo } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../../../../@types/RootState';
import { selectorPriceComposition, SET_IS_OPEN } from '../../../../../../reducers/ipa/priceManager/modals/priceComposition';
import { ComposicaoPrecoModal } from '../../ComposicaoPrecoModal';

type PriceCompositionModalWrapperProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const PriceCompositionModalWrapper = memo(({ priceComposition, closeModal }: PriceCompositionModalWrapperProps) => {
  return <ComposicaoPrecoModal show={priceComposition.isOpen} onHide={closeModal} priceComposition={priceComposition.data} />;
});

const mapStateToProps = (state: RootState) => ({
  priceComposition: selectorPriceComposition(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeModal: () => dispatch(SET_IS_OPEN(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PriceCompositionModalWrapper);
